(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initProductListPremium() {
    /* 
      Intersection Observer for scroll reveal animations.
      Elements with .reveal get the .revealed class when they enter viewport.
    */
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    if (!prefersReducedMotion) {
      const observerOptions = {
        root: null,
        rootMargin: '0px 0px -60px 0px',
        threshold: 0.05
      };

      const revealObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Apply stagger delay from data attribute
            const delay = entry.target.dataset.revealDelay || '0';
            entry.target.style.transitionDelay = `${delay}s`;
            entry.target.classList.add('revealed');
            revealObserver.unobserve(entry.target);
          }
        });
      }, observerOptions);

      document.querySelectorAll('.section-resource-list .reveal').forEach(el => {
        revealObserver.observe(el);
      });
    } else {
      // Immediately show everything if user prefers reduced motion
      document.querySelectorAll('.section-resource-list .reveal').forEach(el => {
        el.classList.add('revealed');
      });
    }

    /* 
      Parallax background effect.
      The .section-background drifts subtly based on scroll position.
    */
    if (!prefersReducedMotion) {
      const parallaxBg = document.querySelector('.section-resource-list .parallax-bg');
      
      if (parallaxBg) {
        let ticking = false;
        
        window.addEventListener('scroll', () => {
          if (!ticking) {
            requestAnimationFrame(() => {
              const section = parallaxBg.closest('.section-resource-list');
              if (!section) return;
              
              const rect = section.getBoundingClientRect();
              const vh = window.innerHeight;
              
              if (rect.top < vh && rect.bottom > 0) {
                const progress = (vh - rect.top) / (vh + rect.height);
                const speed = parseFloat(parallaxBg.dataset.parallaxSpeed) || 0.3;
                const yPos = (progress - 0.5) * 100 * speed;
                parallaxBg.style.transform = `translateY(${yPos}px) scale(1.1)`;
              }
              
              ticking = false;
            });
            ticking = true;
          }
        }, { passive: true });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductListPremium);
  } else {
    initProductListPremium();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
